/* eslint-disable */
//Start JS-Script Code Block taken from master page
$(document).ready(function() {
    if (
        $("input[data-name='isErrorStep']").length == 1 &&
        $("input[data-name='isErrorStep']").val() == 'true'
    ) {
        $('#errorMessage').css('display', 'block');
    }

    if ($.find('[data-popup="glossary"]').length > 0) {
        GetGlossryItems();
    }

    $('a.iframe-popup').each(function(index) {
        var originalAnchor = $(this).attr('href');
        originalAnchor += '?iframe=yes';
        $(this).attr('href', originalAnchor);
    });

    $.each($.find('[data-link-tcmi]'), function(key, value) {
        var tcmId = $(this).attr('data-link-tcmi');
        var hrefLink = $('a[data-tcmi-link="' + tcmId + '"]').attr('href');
        $(this).attr('href', hrefLink);
    });

    $.each($.find('[data-image-tcmi]'), function(key, value) {
        var tcmId = $(this).attr('data-image-tcmi');
        var ImageSrc = $('img[data-tcmi-image="' + tcmId + '"]').attr('src');
        $(this).attr('src', ImageSrc);
    });

    $.each($.find('[data-query-value]'), function(key, value) {
        var qryValue = $(this).attr('data-query-value');
        var qryKey = $(this).attr('data-query-key');
        var anchorhref = $(this).attr('href');
        if (qryValue !== '' && qryKey !== '' && anchorhref !== '') {
            var finalURL = anchorhref + '/' + qryValue;
            $(this).attr('href', finalURL);
        }
    });

    var itemArticle = $('.article-list-item');
    if (itemArticle !== undefined) {
        if (itemArticle.length < 4) {
            $('[name="articleMoreButton"]').parent().remove();
        }
    }

    if ($.find('.fullwidth').length > 0) {
        $('.fullwidth')
            .closest('.container')
            .css({ width: '100%', padding: '0px 0px 0px 0px' });
    }

    if ($('.VideoPopUp').length > 0) {
        $('.VideoPopUp').click(function() {
            var id = '#dialog';
            //Get the screen height and width
            var maskHeight = $(document).height();
            var maskWidth = $(window).width();

            //Set heigth and width to mask to fill up the whole screen
            $('#mask').css({ width: maskWidth, height: maskHeight });

            //transition effect
            $('#mask').fadeIn(500);
            $('#mask').fadeTo('slow', 0.8);

            //Get the window height and width
            var winH = $(window).height() - 480;
            var winW = $(window).width() - 80;

            //Set the popup window to center
            $(id).css('top', winH / 2 - $(id).height() / 2);
            $(id).css('left', winW / 2 - $(id).width() / 2);

            //transition effect
            $(id).fadeIn(2000);

            //if close button is clicked
            $('.window .close').click(function(e) {
                //Cancel the link behavior
                e.preventDefault();

                $('#mask').hide();
                $('.window').hide();
            });

            //if mask is clicked
            $('#mask').click(function() {
                $(this).hide();
                $('.window').hide();
            });
        });
    }

    GoogleAnalytics();
});

function get_hostname(url) {
    var m = url.match(/^http:\/\/[^/]+/);
    return m ? m[0] : null;
}

function get_https_hostname(url) {
    var m = url.match(/^https:\/\/[^/]+/);
    return m ? m[0] : null;
}

// End JS-Script Code Block taken from master page
$(document).ready(function() {
    var pathName = window.location.pathname;
    if (pathName.length > 0 && pathName != '/') {
        pathName = pathName.toLowerCase();
        var targetGroups = $('ul li a.jsSelector');
        if (targetGroups.length > 0) {
            $(targetGroups).each(function(index, currentTargetGroup) {
                var currentTargetControl = $(currentTargetGroup);
                var currentLink = currentTargetControl.attr('href');
                if (pathName.startsWith(currentLink.toLowerCase())) {
                    currentTargetControl.addClass('active');
                }
            });
        }
    }
});
